module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_cod.8657f683.png";